import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EmmaTooltipDirective } from './emma-tooltip.directive';

@NgModule({
  declarations: [
    EmmaTooltipDirective
  ],
  exports: [
    EmmaTooltipDirective
  ],
  imports: [
    CommonModule
  ]
})
export class EmmaTooltipModule { }
